import { getEnvironment, getTheme, type Environment, type Theme } from './utils/env';

// Default flag configuration.
const defaultFeatureFlagValues = {
  canRedirectToErrorPage: true,
  hasActivePastClaimsTabs: false,
  hasActivePastPoliciesTabs: false,
  showManageMyPoliciesButton: true,
  hasImportantInformationPage: true,
  hasSegmentTrackingAnalytics: true,
  hasDocumentsYouNeedSection: true,
  hasNeedToMakeClaimSection: true,
  // Configuration for co-branding.
  isCoBrandedWithCoverMore: false,
  hasDistributedByPartner: false,
  // Configuration for the footer.
  showLinksAfterDisclaimer: false,
  // Configuration for the forms.
  showIconWithFormErrors: false,
  // Configuration for new claim.
  canMakeNewClaimInPortal: false,
};

const featureFlagsPerBrand: Readonly<Record<Theme, typeof defaultFeatureFlagValues>> = {
  default: {
    ...defaultFeatureFlagValues,
  },
  cba: {
    ...defaultFeatureFlagValues,
    isCoBrandedWithCoverMore: true,
    hasDistributedByPartner: true,
  },
  nrma: {
    ...defaultFeatureFlagValues,
    showManageMyPoliciesButton: false,
    showLinksAfterDisclaimer: true,
    showIconWithFormErrors: true,
  },
  'cmdirect-au': {
    ...defaultFeatureFlagValues,
    isCoBrandedWithCoverMore: true,
    hasDistributedByPartner: false,
  },
  'cmdirect-nz': {
    ...defaultFeatureFlagValues,
  },
};

const featureFlagsPerEnvironment: Readonly<Record<Environment, typeof featureFlagsPerBrand>> = {
  dev: {
    ...featureFlagsPerBrand,
    'cmdirect-au': {
      ...featureFlagsPerBrand['cmdirect-au'],
      canMakeNewClaimInPortal: true,
    },
  },
  stg: {
    ...featureFlagsPerBrand,
    'cmdirect-au': {
      ...featureFlagsPerBrand['cmdirect-au'],
      canMakeNewClaimInPortal: true,
    },
  },
  preprod: {
    ...featureFlagsPerBrand,
  },
  prod: {
    ...featureFlagsPerBrand,
  },
};

/**
 * Same as below, but to be used outside of a hook/functional component.
 * Its implementation may differ when connected to the config endpoint.
 */
function getFlags() {
  const theme = getTheme();
  const environment = getEnvironment();
  return featureFlagsPerEnvironment[environment][theme];
}

/**
 * Custom hook to allow access to all the configured feature flags.
 * Follows 'useFlags' pattern from 'launchdarkly-react-client-sdk'.
 */
function useFlags() {
  return getFlags();
}

export { getFlags, useFlags };
